var app = angular.module('octopusApp.tenants');

import React from 'react';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

app.factory("TenantList", function (octopusRepository, octopusTagSets, $filter) {
    return React.createClass({
        propTypes: {
            tenants: React.PropTypes.array.isRequired
        },

        getInitialState: function () {
            return { allTagSets: [], tenantsMissingVariables: [] };
        },

        getDefaultProps: function () {
            return { tenants: [] };
        },

        componentDidMount: function () {
            var self = this;
            octopusTagSets.getAll().then(function (tagSets) {
                octopusRepository.Tenants.missingVariables(false).then(function (result) {
                    self.setState({allTagSets: tagSets, tenantsMissingVariables: _.pluck(result, 'TenantId')});
                });
            });
        },

        getTag: function (canonicalTagName) {
            var tagSetName = canonicalTagName.split("/")[0];
            for (var i in this.state.allTagSets) {
                var tagSet = this.state.allTagSets[i];
                if (tagSet.Name !== tagSetName) {
                    continue;
                }

                for (var j in tagSet.Tags) {
                    var tag = tagSet.Tags[j];
                    if (canonicalTagName === tag.CanonicalTagName) {
                        return tag;
                    }
                }
            }
            return null;
        },

        isTenantMissingVariable: function (tenant) {
            if (!this.state.tenantsMissingVariables) {
                return null;
            }
            return this.state.tenantsMissingVariables.indexOf(tenant.Id) !== -1;
        },

        render: function () {
            var self = this;
            var tooltip = React.createElement(Tooltip, {id: 'tooltip'}, 'Some of the required variable values have not been set.');

            var tenantList = this.props.tenants.map(function (tenant, i) {
                var tenantStatus = null;
                if (self.isTenantMissingVariable(tenant)) {
                    tenantStatus = 
                        React.createElement(OverlayTrigger, {key: 'overlayTrigger.' + i, placement: 'top', overlay: tooltip},
                            React.DOM.a({key: 'tenant.status.0.' + i, className: 'tenant-status warning', href: '#/tenants/' + tenant.Id + '/variables'}, [
                                React.DOM.i({key: 'tenant.status.0.2.' + i, 'data-uib-tooltip': 'Some of the required variable values have not been set.', className: 'fa fa-fw fa-warning'}, '')
                            ])
                        );
                }

                return React.DOM.div({key: 'tenants.0.' + i, className: ''}, 
                    React.DOM.div({key: 'tenants.1.' + i, className: 'octo-list-group'}, 
                        React.DOM.div({key: 'tenants.2.' + i, className: 'octo-list-group-item tenant-tile'}, [
                            React.DOM.a({key: 'tenants.2.0.' + i, href: '#/tenants/' + tenant.Id}, [
                                React.DOM.div({key: 'tenants.3.0.' + i, className: 'octo-list-group-item-icon'}, [
                                    React.DOM.img({key: 'tenants.3.1.' + i, src: $filter('resolveLink')(tenant.Links['Logo']), style: {maxHeight: '100px', maxWidth: '100px'}}),
                                ]),

                                React.DOM.h4({key: 'tenants.5.' + i, className: 'octo-list-group-item-heading'}, tenant.Name)
                            ]),

                            React.DOM.div({key: 'tenants.6.' + i, className: 'tenant-tags'}, 
                                tenant.TenantTags.map(function (canonicalTag, j) {
                                    var tag = self.getTag(canonicalTag);
                                    if (!tag) {
                                        return null;
                                    }
                                    var tagTooltip = React.createElement(Tooltip, {id: 'tagTooltip'}, tag.Name);
                                    return React.createElement(OverlayTrigger, {key: 'tagOverlayTrigger.' + i + '.' + j, placement: 'top', overlay: tagTooltip}, 
                                        React.DOM.i({key: 'tenant.tag.0.' + j, className: 'fa fa-square tag-swatch', style: {color: tag.Color}}, '')
                                    );
                                })
                            ),

                            React.DOM.div({key: 'tenants.7.' + i, className: 'tenant-status-group'}, [
                               tenantStatus
                            ])
                        ])
                    )
                );
            });
            return React.DOM.div({className: 'row tenant-list'}, tenantList);
        }
    });
});

app.directive('tenantList', function (reactDirective) {
    return reactDirective('TenantList');
});


// WEBPACK FOOTER //
// ./app/areas/tenants/directives/tenant_list.jsx